import React, { PropTypes } from 'react';

const NextNavButton = ({ key, style, onClick }) => (
    <a
        key={key}
        className="dtc-watch__carouselNext icon-font-before icon-caret-right-solid-before"
        style={style}
        onClick={onClick}
    />
);

NextNavButton.propTypes = {
    key: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func
};

export default NextNavButton;



// WEBPACK FOOTER //
// ./app/common/page/carousel/NextNavButton.js